import { Injectable } from '@angular/core';
import { FetchHelper } from '../../core/helpers/fetch-helper';
import { Constant } from '../../core/configs/constant';

@Injectable({
  providedIn: 'root',
})
export class CategoriesTypeService {
  getCategoryWithCode() {
    const categoryTypeCode = Constant.CategoryTypeCode.LV;
    return FetchHelper.get(Constant.CATEGORY.GET_BY_CATEGORY_TYPE_CODE, {
      categoryTypeCode,
    });
  }

  getCategoryWithCodeLTTBM() {
    const categoryTypeCode = Constant.CategoryTypeCode.LTTBM;
    return FetchHelper.get(Constant.CATEGORY.GET_BY_CATEGORY_TYPE_CODE, {
      categoryTypeCode,
    });
  }

  getCategoryWithCodeKBC() {
    const categoryTypeCode = Constant.CategoryTypeCode.KBC;
    return FetchHelper.get(Constant.CATEGORY.GET_BY_CATEGORY_TYPE_CODE, {
      categoryTypeCode,
    });
  }
}
